import { SearchForRetail } from '@/client/api';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
/**
 * Builds the tenant details API URL path.
 *
 * @param id - Tenant identifier.
 * @returns URL path in format: /tenant/{id}
 */
export const buildTenantByIdUrl = (id) => `/${SearchForRetail.TENANT_PATH}/${id}`;
/**
 * RTK Query endpoints for tenant details.
 */
export const tenantApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Fetches a tenant by ID.
         *
         * @endpoint GET /tenant/{id}
         */
        getTenantById: builder.query({
            query: ({ id }) => buildTenantByIdUrl(id),
            providesTags: (_result, _error, { id }) => [{ type: CC_API_TAGS.Tenant, id }],
        }),
    }),
});
export const { useGetTenantByIdQuery, useLazyGetTenantByIdQuery } = tenantApi;
